/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, extendObservable } from 'mobx';
import { createResourceStoreHouse } from 'src/luis/core/stores/resourceStoreHouse';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';
import { EntityRoleStore } from 'src/luis/types/stores/entities/EntityRoleStore';
import { EntityRoleStoreHouse } from 'src/luis/types/stores/entities/EntityRoleStoreHouse';
import { SubtractStore } from 'src/luis/types/SubtractStore';

/**
 * A factory function for creating an entity role store house,
 * which houses an array of entity role stores.
 */
export const createEntityRoleStoreHouse = (): EntityRoleStoreHouse => {
    const resourcesStoreHouse = createResourceStoreHouse<EntityRoleStore>();

    const entityRoleStoreHouse: SubtractStore<EntityRoleStoreHouse, ResourceStoreHouse<EntityRoleStore>> = {
        /**
         * Finds an entity by the given name and returns undefined
         * if not found.
         *
         * @param name The name to search with.
         * @returns The entity or undefined if not found.
         */
        findByName(name) {
            return this.items.find(i => i.name === name);
        }
    };

    return extendObservable(resourcesStoreHouse, entityRoleStoreHouse, { findByName: action }, { deep: false });
};
